import { Link } from "react-router-dom";
import { articles, getCategory } from "@/mocks/content";

const trendingIds = ["a4", "a2", "a3", "a6", "a10"];

export default function CoverHero() {
  const main = articles.find((a) => a.id === "a1")!;
  const mainCat = getCategory(main.category);
  const trending = trendingIds
    .map((id) => articles.find((a) => a.id === id))
    .filter(Boolean);

  return (
    <section className="relative overflow-hidden border-b border-background-300/60 bg-background-50">
      {/* faint editorial background decorations */}
      <div className="pointer-events-none absolute -right-24 top-10 select-none font-display text-[16rem] font-black leading-none text-primary-100/60">
        昨日
      </div>

      <div className="mx-auto max-w-7xl px-4 pb-12 pt-10 md:px-6 md:pb-16 md:pt-14">
        <div className="mb-8 flex items-center gap-3">
          <span className="flex h-8 items-center rounded-md bg-primary-500 px-3 text-xs font-bold text-background-50">
            今日首页 · 复盘特辑
          </span>
          <div className="ornate-line h-px flex-1" />
          <span className="hidden text-xs tracking-widest text-foreground-500 sm:block">
            第 118 期 · 每期只做一件事：把热闹理清楚
          </span>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.6fr_1fr] lg:gap-10">
          {/* main featured */}
          <article className="group">
            <Link to={`/article/${main.slug}`} className="block">
              <div className="relative h-[300px] w-full overflow-hidden rounded-2xl md:h-[420px]">
                <img
                  src={main.wideCover ?? main.cover}
                  alt={main.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-black/5" />
                <div className="absolute left-4 top-4 flex items-center gap-2 md:left-6 md:top-6">
                  <span className={`rounded-full px-3 py-1 text-xs font-medium text-background-50 ${mainCat.dot}`}>
                    {mainCat.name}
                  </span>
                  <span className="rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-900">
                    {main.status}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                  <p className="mb-2 text-xs tracking-widest text-background-100/90">
                    {main.kicker}
                  </p>
                  <h1 className="max-w-2xl font-display text-2xl font-black leading-tight text-background-50 md:text-4xl">
                    {main.title}
                  </h1>
                  <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-background-100/90">
                    <span className="flex items-center gap-1">
                      <i className="ri-user-3-line" aria-hidden="true" /> {main.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line" aria-hidden="true" /> 阅读约 {main.readMin} 分钟
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" aria-hidden="true" /> {(main.views / 10000).toFixed(1)}w 围观
                    </span>
                  </div>
                </div>
              </div>
            </Link>
            <div className="mt-5 flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
              <p className="max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
                {main.summary}
              </p>
              <Link
                to={`/article/${main.slug}`}
                className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                进入完整复盘 <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </article>

          {/* trending list */}
          <aside className="flex flex-col rounded-2xl bg-background-100 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="flex items-center gap-2 font-display text-xl font-bold text-foreground-950">
                <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                昨日热议 TOP5
              </h2>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                实时更新
              </span>
            </div>
            <div className="mt-4 flex flex-1 flex-col gap-1">
              {trending.map((a, i) => {
                const cat = getCategory(a!.category);
                return (
                  <Link
                    key={a!.id}
                    to={`/article/${a!.slug}`}
                    className="group flex items-start gap-3 rounded-lg px-2 py-3 transition-colors hover:bg-background-50"
                  >
                    <span className="font-display text-2xl font-black leading-none text-background-300 group-hover:text-primary-500">
                      0{i + 1}
                    </span>
                    <span className="flex flex-1 flex-col">
                      <span className="font-display text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-600">
                        {a!.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                        <span className={`rounded-full px-2 py-0.5 text-[10px] font-medium ${cat.chip}`}>
                          {cat.name}
                        </span>
                        {(a!.views / 10000).toFixed(1)}w 围观
                      </span>
                    </span>
                  </Link>
                );
              })}
            </div>
            <Link
              to="/news"
              className="mt-3 flex items-center justify-center gap-2 rounded-lg border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              查看完整瓜田速递 <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}